import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Chip from '@mui/material/Chip';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Select } from '@mui/material';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import ButtonGroup from '@mui/material/ButtonGroup';
import RefreshIcon from '@mui/icons-material/Refresh';
import { WHATSAPP_MESSAGE_LOG_ENDPOINT, WHATSAPP_MESSAGE_LOG_EXPORT_ENDPOINT } from '../config/urls';
import Menu from '@mui/material/Menu';
import CheckIcon from '@mui/icons-material/Check';
import MessageIcon from '@mui/icons-material/Message';
import FlagIcon from '@mui/icons-material/Flag';
import EventIcon from '@mui/icons-material/Event';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import { Download, Search } from '@mui/icons-material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { useAuth } from '../hooks/AuthProvider';

const columns = [
  { id: 'From', label: 'From' },
  { id: 'Agent', label: 'Agent' },
  { id: 'To', label: 'To' },
  { id: 'Date', label: 'Date' },
  { id: 'Status', label: 'Status' },
  { id: 'Message Type', label: 'Message Type' },
  { id: 'Template', label: 'Template' },
  { id: 'Message', label: 'Message' },
];

export default function UsersTable({ 
    refreshKey, 
    dateInput, 
    controller, 
    setController,
    lastSynced,
    setLastSynced
  }) {
  const [rowCount, setRowCount] = useState(0);
  const [messageData, setmessageData] = useState([]);
  const [userModalState, setUserModalState] = useState({ isOpen: false, selectedClient: null, mode: 'add' });
  const URL = process.env.NODE_ENV === 'production' ? 'api' : `http://localhost:8000/api`;

  const [searchQuery, setSearchQuery] = useState('');
  const [charCount, setCharCount] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [messageTypeFilter, setMessageTypeFilter] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const { getValidToken } = useAuth();
  const [toDate, setToDate] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [senderFilter, setSenderFilter] = useState('');
  const [receiverFilter, setReceiverFilter] = useState('');

  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [appliedDateRange, setAppliedDateRange] = useState([null, null]);
  
  const [messageTypeAnchorEl, setMessageTypeAnchorEl] = useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [senderAnchorEl, setSenderAnchorEl] = useState(null);
  const [receiverAnchorEl, setReceiverAnchorEl] = useState(null);

  // const options = [...new Set(messageData.map(data => data.option))].map(option => (
  //       <MenuItem key={option} value={option}>{captilazeFirstLetter(option)}</MenuItem>
  //   ));

  // const statuses = [...new Set(messageData.map(data => data.status))].map(status => (
  //       <MenuItem key={status} value={status}>{captilazeFirstLetter(status)}</MenuItem>
  //   ));

  const fetchData = async () => {
    let searchDateURL = '';
    if (dateInput) {
      let dateString = dayjs(dateInput).format("YYYY-MM-DD");
      searchDateURL = `&search_date=${dateString}`;
    }

    const queryParams = new URLSearchParams({
        limit: controller.rowsPerPage.toString(),
        offset: (controller.serverSidePage * controller.rowsPerPage).toString(),
        search_query: searchQuery,
        status_filter: statusFilter,
        message_type_filter: messageTypeFilter,
        from_date: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : '',
        to_date: toDate ? dayjs(toDate).format("YYYY-MM-DD") : '',
        sender_filter: senderFilter,
        receiver_filter: receiverFilter
    });

    // const response = await fetch(`${WHATSAPP_MESSAGE_LOG_ENDPOINT}?${queryParams}${searchDateURL}`);
    const tenant = localStorage.getItem('tenant');
    const headers = {
      // "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "X-Tenant-Id": tenant
    };

    try {
      const response = await fetch(`${WHATSAPP_MESSAGE_LOG_ENDPOINT}?${queryParams}${searchDateURL}`, { headers });
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      const jsonData = await response.json();
      setmessageData(jsonData.results);
      setRowCount(jsonData.count);
      setLastSynced(
          jsonData.results.length > 0 ?
              dayjs(jsonData.results[0].last_synced).format("MMMM D, YYYY, h:mm:ss A")
              : null
      );
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  const handleExport = async () => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem('tenant');
      
      // Construct query parameters for filtering
      const queryParams = new URLSearchParams({
        search_query: searchQuery,
        status_filter: statusFilter,
        message_type_filter: messageTypeFilter,
        from_date: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : '',
        to_date: toDate ? dayjs(toDate).format("YYYY-MM-DD") : '',
        sender_filter: senderFilter,
        receiver_filter: receiverFilter
    });
  
      console.log("export URL: ", `${WHATSAPP_MESSAGE_LOG_EXPORT_ENDPOINT}?${queryParams}`);
  
      // Make API request to export endpoint
      const response = await fetch(`${WHATSAPP_MESSAGE_LOG_EXPORT_ENDPOINT}?${queryParams}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          "X-Tenant-Id": tenant
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to export data');
      }
      
      // Create a blob from the response
      const blob = await response.blob();
      
      // Create a link element to download the file
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      
      // Use the current date for the filename
      const today = new Date();
      const dateStr = today.toISOString().split('T')[0];
      a.download = `chat-log-data-${dateStr}.csv`;
      
      // Append to the document and trigger download
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error exporting data:', error.message);
      // Add proper error handling/notification here
    }
  };  

  useEffect(() => {
    fetchData();
  }, [
    controller,
    controller.serverSidePage, 
    controller.rowsPerPage, 
    refreshKey, 
    dateInput,
    searchQuery, 
    statusFilter, 
    messageTypeFilter, 
    fromDate, 
    toDate,
    senderFilter,
    receiverFilter,
    lastSynced
  ]);

  useEffect(() => {
    // Initialize appliedDateRange with current fromDate and toDate
    setAppliedDateRange([fromDate, toDate]);
  }, []);

  const handleDateClick = (event) => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleDateRangeApply = () => {
    // Apply the current date range and update the fromDate/toDate variables
    setFromDate(appliedDateRange[0]);
    setToDate(appliedDateRange[1]);
    setDateAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };

  const handleDateRangeCancel = () => {
    // Reset the temporary date range to match current applied dates
    setAppliedDateRange([fromDate, toDate]);
    setDateAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };

  const handleMessageTypeClick = (event) => {
    setMessageTypeAnchorEl(event.currentTarget);
  };
  
  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };
  
  const handleSenderClick = (event) => {
    setSenderAnchorEl(event.currentTarget);
  };
  
  const handleReceiverClick = (event) => {
    setReceiverAnchorEl(event.currentTarget);
  };
  
  const handleMessageTypeSelect = (type) => {
    const newValue = messageTypeFilter === type ? '' : type;
    setMessageTypeFilter(newValue);
    setMessageTypeAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };
  
  const handleStatusSelect = (status) => {
    const newValue = statusFilter === status ? '' : status;
    setStatusFilter(newValue);
    setStatusAnchorEl(null);
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };
  
  const handleSenderSelect = (value) => {
    setSenderFilter(value);
    setSenderAnchorEl(null);
  };
  
  const handleReceiverSelect = (value) => {
    setReceiverFilter(value);
    setReceiverAnchorEl(null);
  };

  const updateSearchValue = (value) => {
    if (value.length > 50) {
      return;
    }
    setSearchQuery(value);
    setCharCount(value.length);
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };

  const handlePageChange = (event, newPage) => {
    setController(prev => ({
      ...prev,
      page: newPage,
      serverSidePage: newPage  // Sync server-side page with UI page
    }));
  };

  const handleMessageTypeFilterChange = (event) => {
    setMessageTypeFilter(event.target.value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleSenderFilterChange = (event) => {
    setSenderFilter(event.target.value);
  };

  const handleReceiverFilterChange = (event) => {
    setReceiverFilter(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...prev => ({
        ...prev,
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0,
        serverSidePage: 0  // Reset to first page
      })
    });
  };

  const handleFromDateChange = (newValue) => {
    if (toDate && newValue && dayjs(newValue).isAfter(toDate)) {
      setDateError('From Date must be less than or equal to To Date');
    } else {
      setDateError(null);
      setFromDate(newValue);
    }
  };

  const handleToDateChange = (newValue) => {
    if (fromDate && newValue && dayjs(newValue).isBefore(fromDate)) {
      setDateError('To Date must be greater than or equal to From Date');
    } else {
      setDateError(null);
      setToDate(newValue);
    }
  };

  const handleRefresh = () => {
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };

  const handleResetButtonClick = () => {
    setSearchQuery('');
    setStatusFilter('');
    setMessageTypeFilter('');
    setFromDate(null);
    setToDate(null);
    setAppliedDateRange([null, null]);
    setSenderFilter('');
    setReceiverFilter('');
    setController({
      page: 0,
      rowsPerPage: 20
    });
  }

  const [activeButton, setActiveButton] = useState("Message"); // Default active button

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    console.log(`${buttonName} clicked`);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 1,
          m: 1,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
        {/* Filters Row (Including Reset Button) */}
        <Grid 
          container 
          spacing={1} 
          alignItems="center"
          sx={{ 
            overflowX: 'auto', // Allow horizontal scrolling
            pb: 1, // Add padding for scrollbar
            '&::-webkit-scrollbar': { height: '8px' }, // Style scrollbar
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '4px' }
          }}
        >

          {/* Search Filter */}
          <Tooltip title="Search by Phone Number" placement="top" arrow>
            <TextField
              size="small"
              placeholder="Search"
              autoComplete='off'
              value={searchQuery}
              onChange={(e) => updateSearchValue(e.target.value)}
              sx={{ width: 250, mt: 1 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography variant="caption">{charCount}/50</Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Tooltip>

          {/* Date Range Filter */}
          <Grid item >
            <Button 
              variant="outlined" 
              onClick={handleDateClick}
              startIcon={<EventIcon />}
              endIcon={<Box component="span" sx={{ ml: 1 }}>▼</Box>}
              sx={{ 
                textTransform: 'none', 
                borderRadius: 1,
                height: '40px',
                width: '100%',
                mr: 1,
                whiteSpace: 'nowrap',
                '& .MuiChip-root': {
                  maxWidth: fromDate && toDate ? '120px' : '0px',
                  transition: 'max-width 0.2s ease',
                }
              }}
            >
              Date Range
              {fromDate && toDate && (
                <Tooltip title={`${dayjs(fromDate).format('MM/DD/YYYY')} - ${dayjs(toDate).format('MM/DD/YYYY')}`} placement="top" arrow>
                  <Chip 
                    label={`${dayjs(fromDate).format('MM/DD/YYYY')} - ${dayjs(toDate).format('MM/DD/YYYY')}`} 
                    size="small" 
                    onDelete={() => {
                      setFromDate(null);
                      setToDate(null);
                    }}
                    sx={{ ml: 1, maxWidth: { sm: '80px', md: '200px' }, overflow: 'hidden', textOverflow: 'ellipsis' }}
                  />
                </Tooltip>
              )}
            </Button>
            <Menu
              anchorEl={dateAnchorEl}
              open={Boolean(dateAnchorEl)}
              onClose={() => setDateAnchorEl(null)}
              sx={{ width: 200 }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: {
                  width: dateAnchorEl ? dateAnchorEl.offsetWidth * 2 : undefined,
                  maxWidth: '500px',
                },
              }}
            >
              <Box sx={{ p: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="subtitle2">Select date range:</Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <DatePicker
                        label="From"
                        value={appliedDateRange[0]}
                        onChange={(newValue) => {
                          setAppliedDateRange([newValue, appliedDateRange[1]]);
                          // Check for date errors
                          if (appliedDateRange[1] && newValue && dayjs(newValue).isAfter(appliedDateRange[1])) {
                            setDateError('From Date must be less than or equal to To Date');
                          } else {
                            setDateError(null);
                          }
                        }}
                        slotProps={{ 
                          textField: { 
                            size: "small",
                            sx: { 
                              width: '200px',
                              '& .MuiInputBase-root': {
                                height: '40px'
                              }
                            }
                          } 
                        }}
                      />
                      <DatePicker
                        label="To"
                        value={appliedDateRange[1]}
                        onChange={(newValue) => {
                          setAppliedDateRange([appliedDateRange[0], newValue]);
                          // Check for date errors
                          if (appliedDateRange[0] && newValue && dayjs(newValue).isBefore(appliedDateRange[0])) {
                            setDateError('To Date must be greater than or equal to From Date');
                          } else {
                            setDateError(null);
                          }
                        }}
                        slotProps={{ 
                          textField: { 
                            size: "small",
                            sx: { 
                              width: '200px',
                              '& .MuiInputBase-root': {
                                height: '40px'
                              }
                            }
                          } 
                        }}
                      />
                    </Box>
                    {dateError && (
                      <Typography variant="caption" color="error">
                        {dateError}
                      </Typography>
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      <Button onClick={handleDateRangeCancel} variant="outlined">CANCEL</Button>
                      <Button 
                        onClick={handleDateRangeApply} 
                        variant="contained" 
                        disabled={!appliedDateRange[0] || !appliedDateRange[1] || Boolean(dateError)}
                      >
                        APPLY
                      </Button>
                    </Box>
                  </Box>
                </LocalizationProvider>
              </Box>
            </Menu>
          </Grid>

          {/* Message Type Filter */}
          <Grid item >
            <Button 
              variant="outlined" 
              onClick={handleMessageTypeClick}
              startIcon={<MessageIcon />}
              endIcon={<Box component="span" sx={{ ml: 1 }}>▼</Box>}
              sx={{ 
                textTransform: 'none', 
                borderRadius: 1,
                height: '40px',
                width: '100%',
                whiteSpace: 'nowrap'
              }}
            >
              Message Type
              {messageTypeFilter && (
                <Tooltip title={messageTypeFilter} placement="top" arrow>
                  <Chip 
                    label={messageTypeFilter} 
                    size="small" 
                    onDelete={() => handleMessageTypeSelect(messageTypeFilter)}
                    sx={{ ml: 1, maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  />
                </Tooltip>
              )}
            </Button>
            <Menu
              anchorEl={messageTypeAnchorEl}
              open={Boolean(messageTypeAnchorEl)}
              onClose={() => setMessageTypeAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: {
                  width: messageTypeAnchorEl ? messageTypeAnchorEl.offsetWidth : undefined,
                },
              }}
            >
              <MenuItem onClick={() => handleMessageTypeSelect('text')}>
                text
                {messageTypeFilter === 'text' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleMessageTypeSelect('button_reply')}>
                button_reply
                {messageTypeFilter === 'button_reply' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleMessageTypeSelect('list_reply')}>
                list_reply
                {messageTypeFilter === 'list_reply' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleMessageTypeSelect('quick_reply')}>
                quick_reply
                {messageTypeFilter === 'quick_reply' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleMessageTypeSelect('location')}>
                location
                {messageTypeFilter === 'location' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
            </Menu>
          </Grid>

          {/* Status Filter Button */}
          <Grid item >
            <Button 
              variant="outlined" 
              onClick={handleStatusClick}
              startIcon={<FlagIcon />}
              endIcon={<Box component="span" sx={{ ml: 1 }}>▼</Box>}
              sx={{ 
                textTransform: 'none', 
                borderRadius: 1,
                height: '40px',
                width: '100%'
              }}
            >
              Status
              {statusFilter && (
                <Tooltip title={statusFilter} placement="top" arrow>
                  <Chip 
                    label={statusFilter} 
                    size="small" 
                    onDelete={() => handleStatusSelect(statusFilter)}
                    sx={{ ml: 1, maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  />
                </Tooltip>
              )}
            </Button>
            <Menu
              anchorEl={statusAnchorEl}
              open={Boolean(statusAnchorEl)}
              onClose={() => setStatusAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: {
                  width: statusAnchorEl ? statusAnchorEl.offsetWidth : undefined,
                },
              }}
            >
              <MenuItem onClick={() => handleStatusSelect('read')}>
                read
                {statusFilter === 'read' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleStatusSelect('sent')}>
                sent
                {statusFilter === 'sent' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleStatusSelect('delivered')}>
                delivered
                {statusFilter === 'delivered' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
              <MenuItem onClick={() => handleStatusSelect('enqueued')}>
                enqueued
                {statusFilter === 'enqueued' && <CheckIcon sx={{ ml: 1 }} color="success" />}
              </MenuItem>
            </Menu>
          </Grid>
          
          {/* From Filter */}
          {/* <Grid item xs={2} sm={6} md={1.5}>
            <FormControl fullWidth>
              <TextField
                label="From"
                size="small"
                value={senderFilter}
                onChange={handleSenderFilterChange}
                fullWidth
              />
            </FormControl>
          </Grid> */}

          {/* To Filter */}
          {/* <Grid item xs={12} sm={6} md={1.5}>
            <FormControl fullWidth>
              <TextField
                label="To"
                size="small"
                value={receiverFilter}
                onChange={handleReceiverFilterChange}
                fullWidth
              />
            </FormControl>
          </Grid> */}

          {/* Reset Filter Button */}
          <Grid item xs={12} sm={6} md={1} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button 
              variant="outlined" 
              // startIcon={<FilterAltOffIcon />}
              onClick={handleResetButtonClick} 
              sx={{ height: '40px' }}
            >
              Reset
            </Button>
          </Grid>
          <Grid item sx={{ display: 'flex', justifyContent: 'flex-start', marginLeft: 'auto' }}>
            <Button 
              variant="outlined" 
              startIcon={<Download />}
              onClick={handleExport} 
              sx={{ height: '40px' }}
            >
              Export Data
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Table Section */}
      <TableContainer sx={{ maxHeight: 500 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  style={{ minWidth: column.minWidth, border: '1px solid rgba(224, 224, 224, 1)' }}
                >
                  <h3>{column.label}</h3>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {messageData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No match found
                </TableCell>
              </TableRow>
            ) : (
              messageData.map((message, index) => (
                <TableRow key={index}>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.sender}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.agent}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.receiver}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{dayjs(message.logged_at).format("MMMM D, YYYY, h:mm A")}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.status}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.message_type}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message?.template?.template_name}</TableCell>
                  <TableCell align="left" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>{message.message}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        count={rowCount}
        rowsPerPage={controller.rowsPerPage}
        page={controller.page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
